import { render, staticRenderFns } from "./008ceremonyVideo.vue?vue&type=template&id=221616c8&"
import script from "./008ceremonyVideo.vue?vue&type=script&lang=js&"
export * from "./008ceremonyVideo.vue?vue&type=script&lang=js&"
import style0 from "./008ceremonyVideo.vue?vue&type=style&index=0&id=221616c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports